/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Link } from '@coursera/cds-core';
import { Col, Row } from '@coursera/coursera-ui';

import Faqs from 'bundles/design-system/components/Faqs';

import _t from 'i18n!nls/career-plans';

import 'css!./__styles__/CareerPlansFaqs';

export type CareerPlanFaqs = {
  domain?: string;
  question: string;
  answer: string;
};

type Props = {
  faqs: Array<CareerPlanFaqs>;
  entityPageTopic?: string;
  domainName?: string;
  subdomainName?: string;
};

const styles = {
  careerPlanFaqsFooter: css`
    a {
      color: var(--cds-color-blue-700);
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  `,
};

const CareerPlanFaqs = ({ faqs }: Props) => {
  if (!faqs?.length) return null;

  return (
    <Row>
      <Col className="careerPlans-faq careerPlans-grey-bg">
        <div className="careerPlans-container">
          <div className="rc-CareerPlanFaqs">
            <h2 className="careerPlanFaq-heading">{_t('Frequently Asked Questions')}</h2>
            <Faqs faqs={faqs} isBrowsePage />
            <div className="careerPlanFaqs-footer" css={styles.careerPlanFaqsFooter}>
              <FormattedMessage
                message={_t('More questions? Visit the {learnerHelpLink}.')}
                learnerHelpLink={
                  <Link target="_blank" href="https://learner.coursera.help/" variant="standard">
                    {_t('Learner Helper Center')}
                  </Link>
                }
              />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default CareerPlanFaqs;
